import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

// Karta ma'lumotlari (PAN, expire, vendor) endi backend'da saqlanadi
// va `useMyCards()` hook orqali olinadi. Bu store faqat
// "qaysi kartani tanlagan" tanlovini eslab qoladi (P2P uchun qulay).
interface CardsState {
  selectedCardId: string | null;
  setSelectedCardId: (id: string | null) => void;
  clear: () => void;
}

export const useCardsStore = create<CardsState>()(
  persist(
    (set) => ({
      selectedCardId: null,
      setSelectedCardId: (id) => set({ selectedCardId: id }),
      clear: () => set({ selectedCardId: null }),
    }),
    {
      name: "don-cards-selection",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
